import { FC } from 'react';
import Logo, { ILogo } from './Logo';

const LogoText: FC<ILogo> = (props) => {

  return (
    <div className="flex gap-2 items-center">
      <Logo {...props} />
      <div className=" text-primary font-bold">IMPORT</div>
      
    </div>
  );
}

export default LogoText;
